
export default class AddWarehouseRequest {
    public name: string = "";

    public externalId: string | null = null;
    
    public timeTrackingDeviceId: string | null = null;
    
    public formattedAddress: string | null = null;

    public regionId: string = "";
}